import { AnimatePresence, motion } from "framer-motion"
import { HashLink } from 'react-router-hash-link';
import { useAutoHide } from "../animations/useAutoHide";



const Navbar = ({currentPage, setCurrentPage} : any) => {

    const visible = useAutoHide(3000)

    return(
         <AnimatePresence>
            {visible && 
            <motion.div className="fixed bottom-10 md:bottom-20 left-1/2 bg-darkgray bg-opacity-50 rounded-md text-xs md:text-md xl:text-base z-20 navbar hidden md:grid grid-cols-4 grid-rows-1 place-items-center font-martian"
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            exit={{ opacity: 0 }}
            transition={{delay:0.2, duration:0.2}}>
                <HashLink smooth to={'/#home'} className="px-4 md:px-8 py-2 md:py-4 text-center col-start-1 col-end-1 row-start-1 row-end-1 text-gray hover:text-white">
                    <div className={`${currentPage===1 ? 'text-white' : ''} hover:cursor-cur_hover`}>HOME</div>
                </HashLink>
                <HashLink smooth to={'/#projects'} className=" px-4 md:px-8 py-2 md:py-4 text-center col-start-2 col-end-2 row-start-1 row-end-1 text-gray hover:text-white">
                    <div className={`${currentPage===2 ? 'text-white' : ''} hover:cursor-cur_hover`}>PROJECTS</div>
                </HashLink>
                <HashLink smooth to={'/#infos'} className="px-4 md:px-8 py-2 md:py-4 text-center col-start-3 col-end-3 row-start-1 row-end-1 text-gray hover:text-white">
                    <div className={`${currentPage===3 ? 'text-white' : ''} hover:cursor-cur_hover`}>ABOUT</div>
                </HashLink>
                <HashLink smooth to={'/#contact'} className="px-2 mx-2 md:px-6 md:mx-2 my-1 py-1 md:py-2 md:my-2 text-center bg-white rounded-lg col-start-4 col-end-4 row-start-1 row-end-1">
                    {/* <a href="mailto:archive42.at" className="cursor-fancypointer_b active:cursor-fancyactive_b dark:cursor-fancypointer_w dark:active:cursor-fancyactive_w"> */}
                        <div className="w-full h-full hover:cursor-cur_hover rounded-xl text-center justify-center flex items-center text-black hover:font-semibold">CONTACT</div>
                    {/* </a> */}
                </HashLink>            
                <motion.div 
                    layout
                    className="row-start-1 z-30 border-white border rounded-md w-4/5 h-2/3"
                    style={{gridColumnStart: currentPage, gridColumnEnd: currentPage}}
                    transition={
                        {
                            type:'linear',
                            stiffness: 180,
                            damping: 20,
                            ease: 'circInOut',
                            duration: 0.2
                            
                        }
                    }
                    
                    />
            </motion.div>
            }
        </AnimatePresence>
    )
}

export default Navbar